function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { alpha } from "@mui/material/styles";
import { AdditionalColors, SystemColors } from "./colors";
/* ================== [BACKGROUND] ================== */ export const background = {
    backgroundPrimaryBase: {
        light: SystemColors.white,
        dark: SystemColors.gray["900"]
    },
    backgroundSecondary: {
        light: SystemColors.gray["50"],
        dark: SystemColors.gray["800"]
    },
    backgroundTertiary: {
        light: SystemColors.gray["100"],
        dark: SystemColors.gray["700"]
    },
    backgroundQuaternary: {
        light: SystemColors.white,
        dark: SystemColors.gray["900"]
    },
    layerOnBackground1: {
        light: SystemColors.white,
        dark: SystemColors.gray["800"]
    },
    backgroundInverse1: {
        light: SystemColors.gray["900"],
        dark: SystemColors.white
    },
    backgroundInverse2: {
        light: SystemColors.gray["900"],
        dark: SystemColors.gray["800"]
    }
};
export function getBackgroundToken(token, theme) {
    const mode = theme.palette.mode;
    return background[token][mode];
}
/* ================== [BUTTON] ================== */ export const button = {
    buttonPrimary: {
        light: SystemColors.primary["900"],
        dark: SystemColors.primary["800"]
    },
    buttonPrimaryHover: {
        light: SystemColors.primary["600"],
        dark: SystemColors.primary["600"]
    },
    buttonDisabled: {
        light: SystemColors.gray["100"],
        dark: SystemColors.gray["700"]
    },
    buttonSecondary: {
        light: SystemColors.white,
        dark: alpha(SystemColors.gray["900"], 0.08)
    },
    buttonSecondaryBorder: {
        light: SystemColors.gray["300"],
        dark: alpha(SystemColors.gray["400"], 0.32)
    },
    buttonSecondaryHover: {
        light: SystemColors.gray["50"],
        dark: alpha(SystemColors.gray["400"], 0.16)
    },
    buttonTertiary: {
        light: SystemColors.accentBlue["100"],
        dark: alpha(SystemColors.accentBlue["900"], 0.32)
    },
    buttonTertiaryHover: {
        light: SystemColors.accentBlue["200"],
        dark: alpha(SystemColors.accentBlue["900"], 0.48)
    },
    buttonTertiaryBorder: {
        light: SystemColors.accentBlue["500"],
        dark: SystemColors.accentBlue["600"]
    },
    buttonQuarternaryBorder: {
        light: SystemColors.accentBlue["500"],
        dark: SystemColors.accentBlue["600"]
    },
    buttonQuarternaryHover: {
        light: SystemColors.accentBlue["50"],
        dark: alpha(SystemColors.accentBlue["900"], 0.24)
    },
    buttonDestructivePrimary: {
        light: SystemColors.error["600"],
        dark: SystemColors.error["500"]
    },
    buttonDestructivePrimaryHover: {
        light: SystemColors.error["700"],
        dark: SystemColors.error["600"]
    },
    buttonDestructiveSecondaryBorder: {
        light: SystemColors.error["700"],
        dark: SystemColors.error["700"]
    },
    buttonDestructiveQuarternaryBorder: {
        light: SystemColors.error["300"],
        dark: SystemColors.error["600"]
    },
    buttonDestructiveSecondaryHover: {
        light: SystemColors.error["50"],
        dark: SystemColors.error["100"]
    },
    buttonDestructiveTertiaryHover: {
        light: SystemColors.error["100"],
        dark: alpha(SystemColors.error["400"], 0.16)
    },
    buttonGhostGrayHover: {
        light: SystemColors.gray["50"],
        dark: SystemColors.gray["950"]
    },
    buttonGhostPrimaryHover: {
        light: SystemColors.accentBlue["50"],
        dark: alpha(SystemColors.accentBlue["400"], 0.16)
    }
};
export function getButtonToken(token, theme) {
    const mode = theme.palette.mode;
    return button[token][mode];
}
/* ================== [ICON] ================== */ export const icon = {
    iconPrimary: {
        light: SystemColors.primary["950"],
        dark: "white"
    },
    iconSecondary: {
        light: SystemColors.primary["600"],
        dark: SystemColors.primary["400"]
    },
    iconTertiary: {
        light: SystemColors.primary["400"],
        dark: SystemColors.primary["500"]
    },
    iconQuarternary: {
        light: SystemColors.accentBlue["600"],
        dark: SystemColors.accentBlue["400"]
    },
    iconDisabled: {
        light: SystemColors.gray["300"],
        dark: SystemColors.gray["300"]
    },
    iconDestructive: {
        light: SystemColors.error["600"],
        dark: SystemColors.error["600"]
    },
    iconOnColor: {
        light: SystemColors.white,
        dark: SystemColors.white
    },
    iconGray: {
        light: SystemColors.gray["500"],
        dark: SystemColors.gray["400"]
    },
    iconAccent: {
        light: SystemColors.accentBlue["500"],
        dark: SystemColors.accentBlue["400"]
    },
    iconError: {
        light: SystemColors.error["500"],
        dark: SystemColors.error["400"]
    },
    iconWarning: {
        light: SystemColors.warning["500"],
        dark: SystemColors.warning["400"]
    },
    iconSuccess: {
        light: SystemColors.success["500"],
        dark: SystemColors.success["400"]
    },
    iconOceanGreen: {
        light: AdditionalColors.oceangreen["500"],
        dark: AdditionalColors.oceangreen["400"]
    },
    iconIndigo: {
        light: AdditionalColors.indigo["500"],
        dark: AdditionalColors.indigo["400"]
    },
    iconPurple: {
        light: AdditionalColors.purple["500"],
        dark: AdditionalColors.purple["400"]
    }
};
export function getIconToken(token, theme) {
    const mode = theme.palette.mode;
    return icon[token][mode];
}
/* ================== [TEXT] ================== */ export const text = {
    // Defaults
    primary: {
        light: SystemColors.primary["900"],
        dark: SystemColors.white
    },
    secondary: {
        light: SystemColors.primary["700"],
        dark: SystemColors.primary["200"]
    },
    disabled: {
        light: SystemColors.gray["400"],
        dark: SystemColors.gray["600"]
    },
    textPrimary: {
        light: SystemColors.primary["900"],
        dark: SystemColors.white
    },
    textSecondary: {
        light: SystemColors.primary["700"],
        dark: SystemColors.primary["200"]
    },
    textTertiary: {
        light: SystemColors.accentBlue["700"],
        dark: SystemColors.accentBlue["400"]
    },
    textBody: {
        light: SystemColors.gray["600"],
        dark: SystemColors.gray["300"]
    },
    textPlaceholder: {
        light: SystemColors.gray["500"],
        dark: SystemColors.gray["500"]
    },
    textOnColor: {
        light: SystemColors.white,
        dark: SystemColors.white
    },
    textHelper: {
        light: SystemColors.gray["500"],
        dark: SystemColors.gray["400"]
    },
    textError: {
        light: SystemColors.error["700"],
        dark: SystemColors.error["400"]
    },
    textDisabled: {
        light: SystemColors.gray["400"],
        dark: SystemColors.gray["600"]
    },
    textInverseA: {
        light: SystemColors.gray["900"],
        dark: SystemColors.gray["900"]
    },
    textInverseB: {
        light: SystemColors.white,
        dark: SystemColors.gray["900"]
    },
    textWarning: {
        light: SystemColors.warning["700"],
        dark: SystemColors.warning["400"]
    },
    textSuccess: {
        light: SystemColors.success["700"],
        dark: SystemColors.success["400"]
    },
    coachmarkActionA: {
        light: SystemColors.accentBlue["800"],
        dark: SystemColors.accentBlue["800"]
    },
    coachmarkActionB: {
        light: SystemColors.accentBlue["100"],
        dark: SystemColors.accentBlue["100"]
    },
    coachmarkActionBHover: {
        light: SystemColors.white,
        dark: SystemColors.white
    },
    coachmarkBody: {
        light: SystemColors.accentBlue["100"],
        dark: SystemColors.accentBlue["100"]
    }
};
export function getTextToken(token, theme) {
    const mode = theme.palette.mode;
    return text[token][mode];
}
/* ================== [BORDER] ================== */ export const border = {
    border100: {
        light: SystemColors.gray["100"],
        dark: alpha(SystemColors.gray["800"], 0.48)
    },
    border200: {
        light: SystemColors.gray["200"],
        dark: SystemColors.gray["800"]
    },
    border300: {
        light: SystemColors.gray["300"],
        dark: SystemColors.gray["700"]
    },
    border400: {
        light: SystemColors.gray["400"],
        dark: SystemColors.gray["600"]
    },
    borderDestructiveError: {
        light: SystemColors.error["400"],
        dark: SystemColors.error["700"]
    },
    borderDisabled: {
        light: SystemColors.gray["200"],
        dark: alpha(SystemColors.gray["400"], 0.16)
    },
    borderInteractive: {
        light: SystemColors.accentBlue["500"],
        dark: SystemColors.accentBlue["500"]
    },
    borderSubtleGray: {
        light: SystemColors.gray["200"],
        dark: alpha(SystemColors.gray["400"], 0.24)
    },
    borderSubtlePrimary: {
        light: SystemColors.accentBlue["200"],
        dark: alpha(SystemColors.accentBlue["400"], 0.24)
    },
    borderSubtleError: {
        light: SystemColors.error["200"],
        dark: alpha(SystemColors.error["400"], 0.24)
    },
    borderSubtleSuccess: {
        light: SystemColors.success["200"],
        dark: alpha(SystemColors.success["400"], 0.24)
    },
    borderSubtleWarning: {
        light: SystemColors.warning["200"],
        dark: alpha(SystemColors.warning["400"], 0.24)
    },
    borderInteractiveError: {
        light: SystemColors.error["500"],
        dark: SystemColors.error["500"]
    },
    borderColorPrimary: {
        light: SystemColors.accentBlue["300"],
        dark: SystemColors.accentBlue["700"]
    },
    borderColorError: {
        light: SystemColors.error["300"],
        dark: SystemColors.error["700"]
    },
    borderColorWarning: {
        light: SystemColors.warning["300"],
        dark: SystemColors.warning["700"]
    },
    borderColorSuccess: {
        light: SystemColors.success["300"],
        dark: SystemColors.success["700"]
    },
    borderInverse: {
        light: SystemColors.white,
        dark: SystemColors.gray["900"]
    }
};
export function getBorderToken(token, theme) {
    const mode = theme.palette.mode;
    return border[token][mode];
}
/* ================== [TOOGLE] ================== */ export const toggle = {
    toggleUnselected: {
        light: SystemColors.gray["300"],
        dark: SystemColors.gray["700"]
    },
    toggleUnselectedHover: {
        light: SystemColors.gray["400"],
        dark: SystemColors.gray["600"]
    },
    toggleUnselectedThumb: {
        light: SystemColors.white,
        dark: SystemColors.gray["200"]
    },
    toggleSelected: {
        light: SystemColors.primary["900"],
        dark: SystemColors.accentBlue["500"]
    },
    toggleSelectedHover: {
        light: SystemColors.gray["500"],
        dark: SystemColors.accentBlue["600"]
    },
    toggleSelectedThumb: {
        light: SystemColors.white,
        dark: SystemColors.primary["100"]
    },
    toggleDisabled: {
        light: SystemColors.gray["200"],
        dark: SystemColors.gray["700"]
    },
    toggleThumbDisabled: {
        light: SystemColors.gray["50"],
        dark: SystemColors.gray["600"]
    }
};
export function getToggleToken(token, theme) {
    const mode = theme.palette.mode;
    return toggle[token][mode];
}
/* ================== [RangeSlider] ================== */ export const rangeSlider = {
    rangeSliderProgress: {
        light: SystemColors.gray["900"],
        dark: SystemColors.gray["700"]
    },
    rangeSliderHandleBorder: {
        light: SystemColors.gray["300"],
        dark: SystemColors.gray["700"]
    },
    rangeSliderTrackBackground1: {
        light: SystemColors.primary["200"],
        dark: SystemColors.gray["800"]
    },
    rangeSliderHandleFill: {
        light: SystemColors.white,
        dark: SystemColors.primary["200"]
    },
    rangeSliderThumbShadow: {
        light: SystemColors.primary["900"],
        dark: SystemColors.gray["700"]
    }
};
export function getRangeSliderToken(token, theme) {
    const mode = theme.palette.mode;
    return rangeSlider[token][mode];
}
/* ================== [Field] ================== */ export const field = {
    field01: {
        light: SystemColors.white,
        dark: SystemColors.gray["700"]
    },
    field02: {
        light: SystemColors.gray["50"],
        dark: SystemColors.gray["700"]
    },
    fieldSelected: {
        light: SystemColors.gray["50"],
        dark: SystemColors.gray["800"]
    }
};
export function getFieldToken(token, theme) {
    const mode = theme.palette.mode;
    return field[token][mode];
}
/* ================== [Progress bar] ================== */ export const progressBar = {
    trackBackground1: {
        light: SystemColors.gray["200"],
        dark: SystemColors.gray["200"]
    },
    trackFillLine: {
        light: SystemColors.accentBlue["500"],
        dark: SystemColors.accentBlue["500"]
    },
    trackFillLinePositive: {
        light: SystemColors.success["500"],
        dark: SystemColors.success["500"]
    },
    trackFillLineNegative: {
        light: SystemColors.error["500"],
        dark: SystemColors.error["500"]
    },
    trackFillLineWarning: {
        light: SystemColors.warning["500"],
        dark: SystemColors.warning["500"]
    }
};
export function getProgressBarToken(token, theme) {
    const mode = theme.palette.mode;
    return progressBar[token][mode];
}
/* ================== [Chip] ================== */ export const chip = {
    primary: {
        light: SystemColors.accentBlue["100"],
        dark: alpha(SystemColors.primary["900"], 0.32)
    },
    primaryText: {
        light: SystemColors.accentBlue["800"],
        dark: SystemColors.primary["400"]
    },
    primaryBorder: {
        light: SystemColors.accentBlue["300"],
        dark: SystemColors.primary["700"]
    },
    neutral: {
        light: SystemColors.primary["100"],
        dark: alpha(SystemColors.gray["400"], 0.16)
    },
    neutralText: {
        light: SystemColors.primary["800"],
        dark: SystemColors.primary["300"]
    },
    success: {
        light: SystemColors.success["100"],
        dark: alpha(SystemColors.success["900"], 0.32)
    },
    successText: {
        light: SystemColors.success["800"],
        dark: SystemColors.success["400"]
    },
    warning: {
        light: SystemColors.warning["100"],
        dark: alpha(SystemColors.warning["900"], 0.32)
    },
    warningText: {
        light: SystemColors.warning["800"],
        dark: SystemColors.warning["400"]
    },
    error: {
        light: SystemColors.error["100"],
        dark: alpha(SystemColors.error["900"], 0.32)
    },
    errorText: {
        light: SystemColors.error["800"],
        dark: SystemColors.error["400"]
    },
    purple: {
        light: AdditionalColors.purple["100"],
        dark: alpha(AdditionalColors.purple["900"], 0.32)
    },
    purpleText: {
        light: AdditionalColors.purple["800"],
        dark: AdditionalColors.purple["400"]
    },
    filledSelected: {
        light: SystemColors.primary["800"],
        dark: SystemColors.primary["800"]
    },
    outlinedSelected: {
        light: SystemColors.accentBlue["50"],
        dark: SystemColors.accentBlue["50"]
    },
    dismissDefault: {
        light: alpha(SystemColors.black, 0.32),
        dark: alpha(SystemColors.white, 0.32)
    },
    dismissSelectedDefault: {
        light: alpha(SystemColors.white, 0.32),
        dark: alpha(SystemColors.white, 0.32)
    }
};
export function getChipToken(token, theme) {
    const mode = theme.palette.mode;
    return chip[token][mode];
}
/* ================== [Table] ================== */ export const table = {
    tableBackground: {
        light: SystemColors.primary["50"],
        dark: alpha(SystemColors.gray["700"], 0.32)
    },
    tableHover: {
        light: SystemColors.primary["100"],
        dark: alpha(SystemColors.gray["400"], 0.16)
    }
};
export function getTableToken(token, theme) {
    const mode = theme.palette.mode;
    return table[token][mode];
}
/* ================== [ShapeIcon] ================== */ export const shapeIcon = {
    shapeGrayA: {
        light: SystemColors.gray["50"],
        dark: alpha(SystemColors.gray["900"], 0.08)
    },
    shapeGrayB: {
        light: SystemColors.gray["500"],
        dark: SystemColors.gray["500"]
    },
    shapeAccentA: {
        light: SystemColors.accentBlue["50"],
        dark: alpha(SystemColors.accentBlue["400"], 0.24)
    },
    shapeAccentB: {
        light: SystemColors.accentBlue["500"],
        dark: SystemColors.accentBlue["500"]
    },
    shapeErrorA: {
        light: SystemColors.error["50"],
        dark: alpha(SystemColors.error["400"], 0.24)
    },
    shapeErrorB: {
        light: SystemColors.error["500"],
        dark: SystemColors.error["500"]
    },
    shapeWarningA: {
        light: SystemColors.warning["50"],
        dark: alpha(SystemColors.warning["400"], 0.24)
    },
    shapeWarningB: {
        light: SystemColors.warning["500"],
        dark: SystemColors.warning["500"]
    },
    shapeSuccessA: {
        light: SystemColors.success["50"],
        dark: alpha(SystemColors.success["400"], 0.24)
    },
    shapeSuccessB: {
        light: SystemColors.success["500"],
        dark: SystemColors.success["500"]
    },
    shapeOceanGreenA: {
        light: AdditionalColors.oceangreen["50"],
        dark: alpha(AdditionalColors.oceangreen["400"], 0.24)
    },
    shapeOceanGreenB: {
        light: AdditionalColors.oceangreen["500"],
        dark: AdditionalColors.oceangreen["500"]
    },
    shapeIndigoA: {
        light: AdditionalColors.indigo["50"],
        dark: alpha(AdditionalColors.indigo["400"], 0.24)
    },
    shapeIndigoB: {
        light: AdditionalColors.indigo["500"],
        dark: AdditionalColors.indigo["500"]
    },
    shapePurpleA: {
        light: AdditionalColors.purple["50"],
        dark: alpha(AdditionalColors.purple["400"], 0.24)
    },
    shapePurpleB: {
        light: AdditionalColors.purple["500"],
        dark: AdditionalColors.purple["500"]
    }
};
export function getShapeIconToken(token, theme) {
    const mode = theme.palette.mode;
    return shapeIcon[token][mode];
}
/* ================== [Alert tokens] ================== */ export const alertTokens = {
    alertGrayBorder: {
        light: SystemColors.primary["300"],
        dark: SystemColors.primary["700"]
    },
    alertInfoBorder: {
        light: SystemColors.accentBlue["300"],
        dark: SystemColors.accentBlue["700"]
    },
    alertErrorBorder: {
        light: SystemColors.error["300"],
        dark: SystemColors.primary["700"]
    },
    alertWarningBorder: {
        light: SystemColors.warning["300"],
        dark: SystemColors.primary["700"]
    },
    alertSuccessBorder: {
        light: SystemColors.success["300"],
        dark: SystemColors.primary["700"]
    },
    alertGrayColor: {
        light: SystemColors.primary["50"],
        dark: SystemColors.primary["900"]
    },
    alertInfoColor: {
        light: SystemColors.accentBlue["50"],
        dark: SystemColors.accentBlue["900"]
    },
    alertErrorColor: {
        light: SystemColors.error["50"],
        dark: SystemColors.primary["900"]
    },
    alertWarningColor: {
        light: SystemColors.warning["50"],
        dark: SystemColors.primary["900"]
    },
    alertSuccessColor: {
        light: SystemColors.success["50"],
        dark: SystemColors.primary["900"]
    },
    alertDismissPrimary: {
        light: SystemColors.accentBlue["700"],
        dark: SystemColors.accentBlue["400"]
    },
    alertDismissError: {
        light: SystemColors.error["700"],
        dark: SystemColors.error["400"]
    },
    alertDismissWarning: {
        light: SystemColors.warning["700"],
        dark: SystemColors.warning["400"]
    },
    alertDismissSuccess: {
        light: SystemColors.success["700"],
        dark: SystemColors.success["400"]
    }
};
export function getAlertToken(token, theme) {
    const mode = theme.palette.mode;
    return alertTokens[token][mode];
}
/* ================== [Alpha Tokens] ================== */ export const alphaTokens = {
    gray01: {
        light: alpha(SystemColors.gray["400"], 0.16),
        dark: alpha(SystemColors.gray["400"], 0.08)
    },
    gray02: {
        light: alpha(SystemColors.gray["400"], 0.32),
        dark: alpha(SystemColors.gray["400"], 0.24)
    },
    gray03: {
        light: alpha(SystemColors.gray["400"], 0.64),
        dark: alpha(SystemColors.gray["400"], 0.24)
    },
    accent01: {
        light: alpha(SystemColors.accentBlue["400"], 0.16),
        dark: alpha(SystemColors.accentBlue["400"], 0.08)
    },
    accent02: {
        light: alpha(SystemColors.accentBlue["400"], 0.32),
        dark: alpha(SystemColors.accentBlue["400"], 0.24)
    },
    accent03: {
        light: alpha(SystemColors.accentBlue["400"], 0.64),
        dark: alpha(SystemColors.accentBlue["400"], 0.32)
    },
    error01: {
        light: alpha(SystemColors.error["400"], 0.16),
        dark: alpha(SystemColors.error["400"], 0.08)
    },
    error02: {
        light: alpha(SystemColors.error["400"], 0.32),
        dark: alpha(SystemColors.error["400"], 0.24)
    },
    error03: {
        light: alpha(SystemColors.error["400"], 0.64),
        dark: alpha(SystemColors.error["400"], 0.32)
    },
    warning01: {
        light: alpha(SystemColors.warning["400"], 0.16),
        dark: alpha(SystemColors.warning["400"], 0.08)
    },
    warning02: {
        light: alpha(SystemColors.warning["400"], 0.32),
        dark: alpha(SystemColors.warning["400"], 0.24)
    },
    warning03: {
        light: alpha(SystemColors.warning["400"], 0.64),
        dark: alpha(SystemColors.warning["400"], 0.32)
    },
    success01: {
        light: alpha(SystemColors.success["400"], 0.16),
        dark: alpha(SystemColors.success["400"], 0.08)
    },
    success02: {
        light: alpha(SystemColors.success["400"], 0.32),
        dark: alpha(SystemColors.success["400"], 0.24)
    },
    success03: {
        light: alpha(SystemColors.success["400"], 0.64),
        dark: alpha(SystemColors.success["400"], 0.32)
    },
    oceanGreen01: {
        light: alpha(AdditionalColors.oceangreen["400"], 0.16),
        dark: alpha(AdditionalColors.oceangreen["400"], 0.08)
    },
    oceanGreen02: {
        light: alpha(AdditionalColors.oceangreen["400"], 0.32),
        dark: alpha(AdditionalColors.oceangreen["400"], 0.24)
    },
    oceanGreen03: {
        light: alpha(AdditionalColors.oceangreen["400"], 0.64),
        dark: alpha(AdditionalColors.oceangreen["400"], 0.32)
    },
    indigo01: {
        light: alpha(AdditionalColors.indigo["400"], 0.16),
        dark: alpha(AdditionalColors.indigo["400"], 0.08)
    },
    indigo02: {
        light: alpha(AdditionalColors.indigo["400"], 0.32),
        dark: alpha(AdditionalColors.indigo["400"], 0.24)
    },
    indigo03: {
        light: alpha(AdditionalColors.indigo["400"], 0.64),
        dark: alpha(AdditionalColors.indigo["400"], 0.32)
    },
    purple01: {
        light: alpha(AdditionalColors.purple["400"], 0.16),
        dark: alpha(AdditionalColors.purple["400"], 0.08)
    },
    purple02: {
        light: alpha(AdditionalColors.purple["400"], 0.32),
        dark: alpha(AdditionalColors.purple["400"], 0.24)
    },
    purple03: {
        light: alpha(AdditionalColors.purple["400"], 0.64),
        dark: alpha(AdditionalColors.purple["400"], 0.32)
    },
    white16: {
        light: alpha(SystemColors["white"], 0.16),
        dark: alpha(SystemColors.gray["900"], 0.16)
    },
    white32: {
        light: alpha(SystemColors["white"], 0.32),
        dark: alpha(SystemColors.gray["900"], 0.32)
    },
    white64: {
        light: alpha(SystemColors["white"], 0.64),
        dark: alpha(SystemColors.gray["900"], 0.64)
    },
    white72: {
        light: alpha(SystemColors["white"], 0.72),
        dark: alpha(SystemColors.gray["900"], 0.72)
    },
    blackAndWhite: {
        light: alpha(SystemColors.black, 0.08),
        dark: alpha(SystemColors.white, 0.08)
    }
};
export function getAlphaToken(token, theme) {
    const mode = theme.palette.mode;
    return alphaTokens[token][mode];
}
/* ================== [Link tokens] ================== */ export const linkTokens = {
    linkPrimary: {
        light: SystemColors.accentBlue["700"],
        dark: SystemColors.accentBlue["400"]
    },
    linkSecondary: {
        light: SystemColors.primary["700"],
        dark: SystemColors.primary["200"]
    }
};
export function getLinkToken(token, theme) {
    const mode = theme.palette.mode;
    return linkTokens[token][mode];
}
/* ================== [Chart Tokens] ================== */ export const chartTokens = {
    chartGray: {
        light: alpha(SystemColors.gray["400"], 0.16),
        dark: alpha(SystemColors.gray["400"], 0.08)
    },
    chartPrimary: {
        light: alpha(SystemColors.accentBlue["400"], 0.24),
        dark: alpha(SystemColors.accentBlue["400"], 0.24)
    },
    chartError: {
        light: alpha(SystemColors.error["400"], 0.24),
        dark: alpha(SystemColors.error["400"], 0.24)
    },
    chartWarning: {
        light: alpha(SystemColors.warning["400"], 0.24),
        dark: alpha(SystemColors.warning["400"], 0.24)
    },
    chartSuccess: {
        light: alpha(SystemColors.success["400"], 0.24),
        dark: alpha(SystemColors.success["400"], 0.24)
    },
    chartBarSuccess: {
        light: alpha(SystemColors.success["400"], 0.16),
        dark: alpha(SystemColors.success["400"], 0.16)
    },
    chartBarError: {
        light: alpha(SystemColors.error["400"], 0.16),
        dark: alpha(SystemColors.error["400"], 0.16)
    },
    chartBarGrayA: {
        light: SystemColors.primary["100"],
        dark: SystemColors.primary["100"]
    },
    chartBarGrayB: {
        light: SystemColors.primary["300"],
        dark: SystemColors.primary["300"]
    },
    chartBarGrayHover: {
        light: SystemColors.primary["400"],
        dark: SystemColors.primary["400"]
    },
    chartSpend50: {
        light: SystemColors.accentBlue["50"],
        dark: SystemColors.accentBlue["50"]
    },
    chartSpend100: {
        light: SystemColors.accentBlue["100"],
        dark: SystemColors.accentBlue["100"]
    },
    chartSpend200: {
        light: SystemColors.accentBlue["200"],
        dark: SystemColors.accentBlue["200"]
    },
    chartSpend300: {
        light: SystemColors.accentBlue["300"],
        dark: SystemColors.accentBlue["300"]
    },
    chartSpend400: {
        light: SystemColors.accentBlue["400"],
        dark: SystemColors.accentBlue["400"]
    },
    chartSpend500: {
        light: SystemColors.accentBlue["500"],
        dark: SystemColors.accentBlue["500"]
    },
    chartSpend600: {
        light: SystemColors.accentBlue["600"],
        dark: SystemColors.accentBlue["600"]
    },
    chartSpend700: {
        light: SystemColors.accentBlue["700"],
        dark: SystemColors.accentBlue["700"]
    },
    chartSpend800: {
        light: SystemColors.accentBlue["800"],
        dark: SystemColors.accentBlue["800"]
    },
    chartSpend900: {
        light: SystemColors.accentBlue["900"],
        dark: SystemColors.accentBlue["900"]
    },
    chartSpend950: {
        light: SystemColors.accentBlue["950"],
        dark: SystemColors.accentBlue["950"]
    },
    chartEmission50: {
        light: AdditionalColors.oceangreen["50"],
        dark: AdditionalColors.oceangreen["50"]
    },
    chartEmission100: {
        light: AdditionalColors.oceangreen["100"],
        dark: AdditionalColors.oceangreen["100"]
    },
    chartEmission200: {
        light: AdditionalColors.oceangreen["200"],
        dark: AdditionalColors.oceangreen["200"]
    },
    chartEmission300: {
        light: AdditionalColors.oceangreen["300"],
        dark: AdditionalColors.oceangreen["300"]
    },
    chartEmission400: {
        light: AdditionalColors.oceangreen["400"],
        dark: AdditionalColors.oceangreen["400"]
    },
    chartEmission500: {
        light: AdditionalColors.oceangreen["500"],
        dark: AdditionalColors.oceangreen["500"]
    },
    chartEmission600: {
        light: AdditionalColors.oceangreen["600"],
        dark: AdditionalColors.oceangreen["600"]
    },
    chartEmission700: {
        light: AdditionalColors.oceangreen["700"],
        dark: AdditionalColors.oceangreen["700"]
    },
    chartEmission800: {
        light: AdditionalColors.oceangreen["800"],
        dark: AdditionalColors.oceangreen["800"]
    },
    chartEmission900: {
        light: AdditionalColors.oceangreen["900"],
        dark: AdditionalColors.oceangreen["900"]
    },
    chartEmission950: {
        light: AdditionalColors.oceangreen["950"],
        dark: AdditionalColors.oceangreen["950"]
    }
};
export function getChartToken(token, theme) {
    const mode = theme.palette.mode;
    return chartTokens[token][mode];
}
/* ================== [Misc] ================== */ export function extractFromMode(tokens, mode) {
    return Object.keys(tokens).reduce((acc, key)=>{
        const token = tokens[key][mode];
        return _object_spread_props(_object_spread({}, acc), {
            [key]: token
        });
    }, {});
}
export function hexToRGBA(hex, alpha) {
    if (!hex) return undefined;
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(1, 3), 16);
    const b = parseInt(hex.slice(1, 3), 16);
    if (alpha) return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    return `rgb(${r}, ${g}, ${b})`;
}

//# sourceMappingURL=colorTokens.js.map